import { render, staticRenderFns } from "./binding_phone.vue?vue&type=template&id=19bce91a"
import script from "./binding_phone.vue?vue&type=script&lang=js"
export * from "./binding_phone.vue?vue&type=script&lang=js"
import style0 from "./binding_phone.vue?vue&type=style&index=0&id=19bce91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports